import { useSelector } from "react-redux";

import { Reducers } from "../redux/types";

const Permission = (slug: string) => {
  const authState = useSelector((state: Reducers) => state.auth);
  const res = authState.myPermission.list.find((el: any) => el === slug);
  if (res) {
    return true;
  }
  return false;
};

export default Permission;
